import InputBase from './common/input/input-base';
import InputSelect from './common/input/input-select';
import InputReg from './common/input/input-reg';
import InputDateTime from './common/input/input-datetime';

import Modal from './common/modal';
import Reevoo from './common/reevoo';
import Reveal from './common/reveal';
import ParkingMap from './booking-flow/results/airportparking/map';
import ParkingFilter from './booking-flow/results/airportparking/filters';
import ParkingItem from './booking-flow/results/airportparking/item';

import StepsLoader from './common/steps-loader';

import BookingHeader from './booking-flow/confirmation-view/header';
import BookingFooter from './booking-flow/confirmation-view/footer';
import BookingIntro from './booking-flow/confirmation-view/intro';
import BookingParkingItem from './booking-flow/confirmation-view/parking-item';
import BookingHotelItem from './booking-flow/confirmation-view/hotel-item';
import BookingLoungeItem from './booking-flow/confirmation-view/lounge-item';
import BookingTerms from './booking-flow/confirmation-view/terms';
import BookingCustomer from './booking-flow/confirmation-view/customer-services';
import BookingSummary from './booking-flow/confirmation-view/summary';

import HotelFilter from './booking-flow/results/airporthotel/filters';
import HotelOverview from './booking-flow/results/airporthotel/overview';
import HotelItem from './booking-flow/results/airporthotel/item';

import LoungeFilter from './booking-flow/results/airportlounge/filters';
import LoungeOverview from './booking-flow/results/airportlounge/overview';
import LoungeItem from './booking-flow/results/airportlounge/item';

import AddonItemLounge from './booking-flow/upgrades/airportlounge/item';

import Marker from './booking-flow/results/airportparking/marker';

import BasketParkingItem from './booking-flow/payment/basket/parkingItem';
import BasketAddonItem from './booking-flow/payment/basket/addonItem';
import BasketHotelItem from './booking-flow/payment/basket/hotelItem';
import BasketLoungeItem from './booking-flow/payment/basket/loungeItem';

import Basket from './booking-flow/payment/basket';
import Customer from './booking-flow/payment/customer-form';
import Travel from './booking-flow/payment/travel-form';
import Vehicles from './booking-flow/payment/vehicles-form';
import Addons from './booking-flow/payment/addons-form';
import Payment from './booking-flow/payment/payment-form';
import Edit from './booking-flow/payment/edit';
import AccountCreate from './booking-flow/payment/account-create';

import RightCol from './common/more-info/right-col';
import HotelRightCol from './common/more-info/hotel-right-col';
import LoungeRightCol from './common/more-info/lounge-right-col';
import ReturnTab from './common/more-info/tabs/return';
import ArrivalTab from './common/more-info/tabs/arrival';
import SummaryTab from './common/more-info/tabs/summary';
import ImportantTab from './common/more-info/tabs/important';
import ReviewsTab from './common/more-info/tabs/reviews';
import MapTab from './common/more-info/tabs/map';
import HotelOverviewTab from './common/more-info/tabs/hotel-overview';
import LoungeOverviewTab from './common/more-info/tabs/lounge-overview';
import LoungeInformationTab from './common/more-info/tabs/lounge-information';
import HotelInformationTab from './common/more-info/tabs/hotel-information';

import PageBanner from './common/page-banner';

import Timeout from './common/timeout';
import MoreInfo from './common/more-info';

import SaveForLater from './common/save-for-later';
import ForgottenPassword from './common/forgotten-password';

export {

  // Create account password
  AccountCreate,

  // General
  Reevoo,
  PageBanner,
  Modal,
  Timeout,
  MoreInfo,
  RightCol,
  HotelRightCol,
  LoungeRightCol,
  ReturnTab,
  SummaryTab,
  ArrivalTab,
  HotelOverviewTab,
  LoungeOverviewTab,
  HotelInformationTab,
  LoungeInformationTab,
  MapTab,
  ImportantTab,
  ReviewsTab,
  Reveal,
  SaveForLater,
  ForgottenPassword,

  // Results
  ParkingFilter,
  ParkingItem,
  ParkingMap,
  Marker,
  HotelFilter,
  HotelOverview,
  HotelItem,
  LoungeFilter,
  LoungeOverview,
  LoungeItem,
  AddonItemLounge,

  // Payment
  Basket,
  BasketParkingItem,
  BasketAddonItem,
  BasketHotelItem,
  BasketLoungeItem,
  Customer,
  Vehicles,
  Travel,
  Addons,
  Payment,

  // Input
  InputBase,
  InputSelect,
  InputReg,
  InputDateTime,

  // Confirmation view
  BookingHeader,
  BookingFooter,
  BookingIntro,
  BookingParkingItem,
  BookingTerms,
  BookingCustomer,
  BookingSummary,
  BookingHotelItem,
  BookingLoungeItem,
  Edit,

  // Loader
  StepsLoader
}